var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "_flexbtwn _ai-c" }, [
    _c("div", [
      _vm.previousUpdateUrl
        ? _c(
            "a",
            {
              staticClass: "gfu-link gfu-link--accent",
              attrs: {
                href: _vm.previousUpdateUrl,
                "data-qa": "project-update-nav:previous",
              },
              on: {
                click: function ($event) {
                  return _vm.trackClick("previous")
                },
              },
            },
            [
              _c("base-icon", { attrs: { name: "chevron-left" } }),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.Resources.ProjectUpdates.PreviousUpdateLink) +
                  "\n        "
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", [
      _vm.nextUpdateUrl
        ? _c(
            "a",
            {
              staticClass: "gfu-link gfu-link--accent",
              attrs: {
                href: _vm.nextUpdateUrl,
                "data-qa": "project-update-nav:next",
              },
              on: {
                click: function ($event) {
                  return _vm.trackClick("next")
                },
              },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.Resources.ProjectUpdates.NextUpdateLink) +
                  "\n            "
              ),
              _c("base-icon", { attrs: { name: "chevron-right" } }),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }